import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useReminder, Reminder } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Reminder>
      useData={useReminder}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

